import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessibilitySettingsComponent } from '@app/shared/component/accessibility-settings/accessibility-settings.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { databaseToBootstrap, dateOnly } from '@app/shared/utils';
import * as moment from 'moment';
// import * as moment from 'moment-timezone';
import { fromEvent, Observable, Subscription } from 'rxjs';
// import { ShareTypeDialog } from './share-type-dialog/share-type-dialog.component';

@AutoUnsubscribe()
@Component({
  selector: 'share-type-control',
  templateUrl: './share-type-control.component.html',
  styleUrls: ['./share-type-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareTypeControl implements OnInit, OnDestroy {
  @Input('sharedObjectType') sharedObjectType;
  @Input('existingShareDetails') existingShareDetails;
  @Input('displayOnly') displayOnly = false;
  @Input('sharedToFirstName') sharedToFirstName = false;
  @Input('sharedToLastName') sharedToLastName;
  @Input('sharedToProfileImage') sharedToProfileImage;
  @Input() onlyEditIcon;
  @Input() existingUserData;
  @Input() showShareTypeOptions;
  @Input() generalPermission;
  @Output('onUpdate') onUpdate: EventEmitter<any> = new EventEmitter();
  @Output('onDelete') onDelete: EventEmitter<any> = new EventEmitter();

  shareDetails;
  shareTypeText = 'Accessible Now';
  shareTypeSelectedDate = dateOnly(new Date(Date.now()));
  isSealed: boolean = false;
  screenWidth: number;
  resizeObservable$: Observable<Event>;
  subscription: Subscription = new Subscription();
  // localTimeZone = moment.tz.guess();

  constructor(private cd: ChangeDetectorRef, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    if (this.existingShareDetails) {
      const data = JSON.parse(this.existingShareDetails);
      this.shareDetails = {
        end_date: data.end_date,
        share_date: data.share_date,
        is_sealed: data.is_sealed,
        is_editable: data.is_editable,
      };

      this.shareTypeSelectedDate = moment(this.shareDetails.share_date);
      this.isSealed = this.shareDetails.is_sealed;
      this.buildShareTypeText();
    }
  }

  deleteExistingUser() {
    this.onDelete.emit(this.existingUserData);
  }

  shareTypeSelectionClicked() {
    const shareTypeDialog = this.dialog.open(AccessibilitySettingsComponent, {
      data: {
        sharedObjectType: this.sharedObjectType,
        shareDetails: this.shareDetails,
        profile_image: this.sharedToProfileImage,
        name: this.sharedToFirstName + ' ' + this.sharedToLastName,
        data: {
          generalPermission: this.generalPermission,
        },
      },
      // width: '250px',
      // height: '410px',
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });

    this.subscription.add(
      shareTypeDialog.afterClosed().subscribe((results) => {
        if (results) {
          // this.shareDetails = results;
          this.buildShareTypeText();

          //call update to parent component
          this.onUpdate.emit(results);
          this.cd.markForCheck();
        }
      })
    );

    return false;
  }

  checkAccessibilityTag(date): string {
    const formatedDate = moment();
    if (date) {
      const diffInDays = moment(date).diff(formatedDate, 'hours');

      if (diffInDays <= 0) {
        return 'Now';
      }

      if (diffInDays > 0) {
        return '';
      }
    } else {
      return 'Later';
    }
  }

  checkAccessibility(date): string {
    const formatedDate = moment();
    if (date) {
      const diffInDays = moment(date).diff(formatedDate, 'hours');

      if (diffInDays <= 0) {
        return 'now';
      }

      if (diffInDays > 0) {
        return 'sealed';
      }
    } else {
      return 'later';
    }
  }

  buildShareTypeText() {
    if (!this.shareDetails.share_date) {
      this.shareTypeText = 'Accessible on a later date';
    } else if (new Date(this.shareDetails.share_date) < new Date(Date.now())) {
      this.shareTypeText = 'Accessible Now';
    } else {
      const displayDate = databaseToBootstrap(new Date(this.shareDetails.share_date).toUTCString());
      const selectedDate = new Date(this.shareDetails.share_date);

      const momentDate = moment(selectedDate);

      // this.shareTypeText = `Accessible on ${displayDate.month.slice(0, 3)} ${displayDate.day} ${displayDate.year}`;

      this.shareTypeText = `Accessible on ${moment(momentDate).format('MMM DD YYYY')}`;
    }
    this.isSealed = this.shareDetails.is_sealed;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
